














































import { Component, Prop, Ref, Vue } from 'vue-property-decorator'

@Component
export default class Gallery extends Vue {
  @Ref('thumbListWrapper') readonly thumbListWrapper!: HTMLDivElement
  @Prop({ required: true }) thumbList!: any

  private currentIndex: number = 0

  /**
   * 切换到指定页的图片
   * @param i 图片的index
   */
  public async switchItem (i: number) {
    this.currentIndex = i
    this.$emit('switch', i)
    const elm = this.thumbListWrapper.children[i]
    elm.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
  }

  /**
   * 获取上一张图片
   */
  private preHandler () {
    if (this.currentIndex > 0) {
      this.switchItem(this.currentIndex - 1)
    }
  }

  /**
   * 获取下一张图片
   */
  private nextHandler () {
    if (this.currentIndex < this.thumbList.length - 1) {
      this.switchItem(this.currentIndex + 1)
    }
  }

  /**
   * 水平滚动
   */
  private mouseWheelListener () {
    this.thumbListWrapper.addEventListener('mousewheel', function (this: any, event: Event) {
      const delta = (event as WheelEvent).deltaY
      this.scrollLeft -= delta
      event.preventDefault()
    }, false)
  }

  mounted () {
    this.mouseWheelListener()
  }
}
